import { render } from "./recuperarContrasena.vue?vue&type=template&id=565588ac&scoped=true"
import script from "./recuperarContrasena.vue?vue&type=script&lang=js"
export * from "./recuperarContrasena.vue?vue&type=script&lang=js"

import "./recuperarContrasena.vue?vue&type=style&index=0&id=565588ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565588ac"]])

export default __exports__